import React from 'react';
import { Section } from '@radix-ui/themes';

import PageTitle from 'components/layout/PageTitle';
import BoardDetail from 'components/board/BoardDetail';

// 게시판 관리 > 성과자료실 관리 > 상세
export default function PerformanceDetail() {
  const boardType = 'performance';

  return (
    <Section>
      <PageTitle title="성과자료실 상세" />
      <BoardDetail boardType={boardType} />
    </Section>
  );
}
